"use client";

import { useTranslations } from "next-intl";
import { servicesMenuItems } from "@/data/services-menu";

export type ServiceMenuItem = {
  slug: string;
  image: string;
  title: string;
  description: string;
};

export function useServiceMenuItems(): ServiceMenuItem[] {
  const t = useTranslations("services.menu");
  return servicesMenuItems.map((item) => ({
    ...item,
    title: t(`${item.slug}.title`),
    description: t(`${item.slug}.description`),
  }));
}
